import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { BREADCRUMBS } from 'config';
import { ANALYTICS_CONSTANTS } from 'config';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';
import { BulkUploadService } from './bulk-upload.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { BulkWizardDataService } from './../bulk-wizard-data-service';
declare var logoutCurrentUser: any;

@Component({
  selector: 'app-bulk-user-upload',
  providers: [BulkUploadService, BulkWizardDataService],
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./../bulk-users.component.scss']
})
export class BulkUploadComponent implements OnInit {

  @ViewChild('fileInput') inputEl: ElementRef;
  uploadErrorMessage: string;
  uploadFileName: string;
  uploadStatus: boolean;
  bulkUploadError = '';
  bulkUploadFlag: boolean;

  constructor(
    private stepindicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService,
    private activatedRoute: ActivatedRoute,
    private bulkUploadService: BulkUploadService,
    private router: Router,
    private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService,
    private bulkWizardDataService: BulkWizardDataService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService
  ) {
  }

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('navigationUrl') !== '/bulkUsers/bulk-upload') {
      this.router.navigate(['/home']);
    }else {
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
      this.uploadStatus = false;
      this.bulkUploadFlag = true;
    }
    this.bulkWizardDataService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'Bulk User upload - Upload',
      ANALYTICS_CONSTANTS.FRIENDLY_NAME_BULKUPLOAD_STEP2);
  }

  upload() {
    const inputEl: HTMLInputElement = this.inputEl.nativeElement;
    const fileCount: number = inputEl.files.length;
    const formData = new FormData();
    if (fileCount > 0) { // a file was selected
      for (let i = 0; i < fileCount; i++) {
        formData.append('file', inputEl.files.item(i), inputEl.files.item(i).name);
      }
    }
    const fileExt = inputEl.files.item(0).name.split('.').pop();
    this.uploadFileName = inputEl.files.item(0).name;
    formData.append('file', fileExt);
    if (fileExt !== 'csv' && fileExt !== 'xlsx') {
      this.bulkUploadError = "We can't process this type of file. Please check the file type and upload your file again.";
      this.utilityService.loadFocusOnTop();
      this.bulkUploadFlag = true;
      this.uploadStatus = false;
      // window.scrollTo(0, 0);
    } else {
      this.pageloaderService.setPageLoaderStatus(false);
      this.bulkUploadService.uploadFileService(formData).subscribe(orderResponse => {
        sessionStorage.setItem('bulk-user', JSON.stringify(orderResponse));
        this.uploadStatus = true;
        this.bulkUploadFlag = false;
        this.bulkUploadError = '';
        this.pageloaderService.setPageLoaderStatus(true);
        this.utilityService.loadFocusOnTop();
      }, error => {
        this.bulkUploadFlag = true;
        this.uploadStatus = false;
        this.handleError(error);
        this.pageloaderService.setPageLoaderStatus(true);
        // window.scrollTo(0, 0);
      });
    }
  }

  handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      let isFailureUser = false;
      if (error.status === 401) {
        this.bulkUploadError = 'Session Expired.Please login again';
        logoutCurrentUser(true);
      } else if (error.status === 404 && !!error.error[0].errorDescription) {
        this.bulkUploadError = error.error[0].errorDescription;
        isFailureUser = true;
      } else {
        this.bulkUploadError = 'We couldn\'t complete your request. Please try again later. ';
      }
      if (isFailureUser) {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse', 'Failure_User');
      } else {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  cancel() {
    this.router.navigate(['bulkUsers/bulk-action']);
    sessionStorage.removeItem('navigationUrl');
  }

  gotoReview() {
    sessionStorage.removeItem('navigationUrl');
    sessionStorage.setItem('bulk-previousRoute', '/bulkUsers/bulk-upload'); // ag4104 - can we use breadcrumbservice ?
    this.router.navigate(['bulkUsers/bulk-review']);
  }
}
